import React from 'react';
import { K_ICONS } from './icons';

/**
 * Kathrefits AI — shared helpers. Styling lives in a hand-editable stylesheet
 * (`apps/web/public/styles/kathreftis.css`, served at /styles/kathreftis.css);
 * components here only emit semantic class names — NO inline styles, NO
 * styled-components, NO third-party CSS/JS/fonts. Icons are inline SVG.
 */

/** Loads the stylesheet once (rendered by the kNav block, first on the page). */
export const KHead = () => <link rel="stylesheet" href="/styles/kathreftis.css" />;

/** Two-bar logo mark. `onNavy` flips the tall bar to white (dark backgrounds). */
export const KMark = ({ onNavy }: { onNavy?: boolean }) => (
  <span className={onNavy ? 'k-mark k-mark--onNavy' : 'k-mark'}>
    <i className="k-mark-a" />
    <i className="k-mark-b" />
  </span>
);

/** Inline SVG icon (Phosphor set). Colour comes from CSS (`fill:currentColor`);
 *  pass a `className` to target it (e.g. `k-card__icon`). Self-contained. */
export function KIcon({ name, size = 20, className }: { name: string; size?: number; className?: string }) {
  const inner = K_ICONS[name] ?? K_ICONS['ph ph-check'] ?? '';
  return (
    <svg
      className={className ? `k-icon ${className}` : 'k-icon'}
      width={size} height={size} viewBox="0 0 256 256" fill="currentColor"
      aria-hidden="true" dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}

/** Image slot: photo if a URL is set, else a labelled placeholder. Size via a
 *  `k-slot--h*` modifier class. */
export function KImage({ src, alt, className }: { src?: string; alt?: string; className?: string }) {
  return (
    <div className={className ? `k-slot ${className}` : 'k-slot'}>
      {src ? <img src={src} alt={alt ?? ''} /> : <span>{alt || 'Image'}</span>}
    </div>
  );
}
